import React, { useEffect, useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
import axios from '../../api/axios';
import Skeleton from '@material-ui/lab/Skeleton';
import Badge from '@material-ui/core/Badge';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles, withStyles } from '@material-ui/core/styles';

const OnlineBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}))(Badge);
const OfflineBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: 'gray',
    color: 'gray',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      border: '1px solid currentColor',
      content: '""',
    },
  },
}))(Badge);

const useStyles = makeStyles((theme) => ({
  hasAvatar: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
  },
  noAvatar: {
    display: 'inline-block',
  },
  avatar: {
    width: 30,
    height: 30,
  },
  userName: { marginLeft: theme.spacing(0.5) },
}));

const CustomerLink = ({ user, avatar = true }) => {
  const classes = useStyles();
  const [customer, setCustomer] = useState(null);
  useEffect(() => {
    if (typeof user === 'object') {
      setCustomer(user);
    } else {
      (async () => {
        try {
          const { data } = await axios.get(`/api/v1/admin/user/${user}`);
          setCustomer(data);
        } catch (error) {
          console.error(JSON.stringify(error, null, 2));
        }
      })();
    }
  }, []);

  return (
    <Fragment>
      {customer === null ? (
        <Skeleton variant="text" width={40} />
      ) : (
        <Link
          to={`/protected/admin/users/customer/${customer._id}`}
          className={avatar ? classes.hasAvatar : classes.noAvatar}
        >
          {avatar && (
            <>
              {customer.online ? (
                <OnlineBadge
                  overlap="circular"
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  variant="dot"
                >
                  <Avatar className={classes.avatar}>
                    {customer.legal
                      ? customer.company.slice(0, 1)
                      : customer.lastName.slice(0, 1)}
                  </Avatar>
                </OnlineBadge>
              ) : (
                <OfflineBadge
                  overlap="circular"
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  variant="dot"
                >
                  <Avatar className={classes.avatar}>
                    {customer.legal && customer.company
                      ? customer.company.slice(0, 1)
                      : customer.lastName.slice(0, 1)}
                  </Avatar>
                </OfflineBadge>
              )}
            </>
          )}
          <div className={classes.userName}>
            {customer.legal && customer.company
              ? customer.company
              : customer.lastName}
          </div>
        </Link>
      )}
    </Fragment>
  );
};

export default React.memo(CustomerLink);
